module.exports = __webpack_public_path__ + "img/chart.8e18b4e3.png";